import { createBrowserRouter, Outlet } from 'react-router-dom';
import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import CustomDomainGuard from './CustomDomainGuard';

// route imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';

const ErrorPage = Loadable(lazy(() => import('pages/error_page')));
const ForbiddenPage = Loadable(lazy(() => import('pages/forbidden')));

// ==============================|| GUARDED ROOT ||============================== //

const GuardedRoot = () => (
  <CustomDomainGuard>
    <Outlet />
  </CustomDomainGuard>
);

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <GuardedRoot />,
      children: [
        LoginRoutes,
        MainRoutes,
        { path: 'error', element: <ErrorPage /> },
        { path: 'forbidden', element: <ForbiddenPage /> },
        { path: '*', element: <ErrorPage /> }
      ]
    }
  ],
  { basename: import.meta.env.VITE_APP_BASE_NAME }
);

export default router;
